import React from 'react';
import './About.css';

function About() {
    return (
        <div className="about-container">
            <section className="about-section">
                <h1>Our Mission</h1>

                <div>
                    <p>
                        Our firm is ready, willing, and capable of taking on any case where you and yours have been wrongfully treated, scammed, harassed, or defrauded. We have successfully and competently handled everything from underlying consumer transactions of only $4.00 to high-stakes business litigation with over $500 million in dispute.
                    </p>

                    <p>
                        While we began our firm with a focus on consumer transactions between individuals and businesses, we now handle a wide range of complex business litigation as well as employment cases of harassment, retaliation, and wage and hour violations. When necessary, we will even pursue your case through an appeal to secure your interests.
                    </p>

                        <p><strong>No matter who is on the other side of the table, we do not waver in our representation, loyalty, and dedication to our clients.</strong></p>
    

                    <p>
                        We endeavor to protect the common person and the underdog who is far too often mistreated by business entities that believe they can get away with the most malicious acts of misconduct without any kind of repercussions. Our hope is that our clients will always know they can call on us to protect their interests and be there to fight on their behalf.
                    </p>
                </div>
            </section>
        </div>
    );
}

export default About;